var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWorkLogs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.17835 4.55763C9.01071 4.39 8.78021 4.2957 8.53923 4.2957C8.03632 4.2957 7.63818 4.70432 7.63818 5.19675V8.69617C7.63818 8.91619 7.722 9.12574 7.85821 9.29338L11.1062 12.9919C11.2529 13.17 11.4834 13.2747 11.7243 13.2852H11.7872C12.0072 13.2852 12.2272 13.2119 12.3739 13.0757C12.552 12.9185 12.6673 12.6985 12.6778 12.4575C12.6987 12.2165 12.6149 11.986 12.4577 11.8079L9.44028 8.3609V5.20723C9.44028 4.96625 9.34598 4.73575 9.17835 4.56811V4.55763Z",
    fill: "#FF6F00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8009 7.07218C17.759 6.86263 17.6228 6.67404 17.4342 6.55879C17.2456 6.44354 17.0256 6.40163 16.8161 6.44354C16.596 6.49593 16.4179 6.62165 16.3027 6.79976C16.1874 6.98836 16.1455 7.20838 16.1979 7.41793C16.3132 7.94179 16.3655 8.47613 16.3655 9.01048C16.3655 13.0652 13.0652 16.3655 9.01048 16.3655C4.95576 16.3655 1.65541 13.0652 1.65541 9.01048C1.65541 4.95576 4.95576 1.65542 9.01048 1.65542C9.77532 1.65542 10.5297 1.77067 11.2526 2.00117C11.4622 2.07451 11.6927 2.05355 11.8813 1.94878C12.0803 1.84401 12.2165 1.67637 12.2899 1.46682C12.3527 1.25728 12.3423 1.03726 12.2375 0.838187C12.1327 0.639118 11.9651 0.502914 11.7555 0.429573C10.865 0.146686 9.94296 0 9 0C4.03376 0 0 4.03376 0 9C0 13.9662 4.03376 18 9 18C13.9662 18 18 13.9662 18 9C18 8.33993 17.9267 7.69034 17.7905 7.05123L17.8009 7.07218Z",
    fill: "#FF6F00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0908 3.45751C12.0908 3.84517 12.4051 4.149 12.7823 4.149H14.1339V5.50058C14.1339 5.88824 14.4482 6.20255 14.8254 6.20255C15.2026 6.20255 15.5169 5.88824 15.5169 5.50058V4.149H16.8685C17.2561 4.149 17.56 3.83469 17.56 3.45751C17.56 3.08032 17.2457 2.766 16.8685 2.766H15.5169V1.41443C15.5169 1.02677 15.2026 0.722931 14.8254 0.722931C14.4482 0.722931 14.1339 1.03725 14.1339 1.41443V2.766H12.7823C12.3947 2.766 12.0908 3.08032 12.0908 3.45751Z",
    fill: "#FF6F00"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkLogs);
export default __webpack_public_path__ + "static/media/work_logs.38192337cd962e3953a7903d24960174.svg";
export { ForwardRef as ReactComponent };